// Shared UI highlight colors for badges and similar emphasis states.
// Use these constants instead of repeating raw hex values in components.
export const BRAND_PRIMARY_LIGHT = "#3d3b8e";
export const BRAND_PRIMARY_DARK = "#4f46e5";
export const BADGE_HIGHLIGHT_BG = "#dbeafe";
export const BADGE_HIGHLIGHT_BORDER = "#93c5fd";
export const BADGE_HIGHLIGHT_TEXT = "#1d4ed8";
export const DARKMODE_SPINNER_COLOR = "#ffffff";
export const TODO_PRIORITY_COLORS = {
    low: { bg: "#E8F5E9", text: "#2E7D32" },
    normal: { bg: "#E3F2FD", text: "#1565C0" },
    high: { bg: "#FFF3E0", text: "#EF6C00" },
    urgent: { bg: "#FFEBEE", text: "#C62828" },
} as const;

export const BRANDED_CHECKBOX_SX = {
    color: "text.secondary",
    "&.Mui-checked": {
        color: "primary.main",
    },
};
